/**
 * Do feature detection, to figure out which polyfills needs to be imported.
 **/
export const loadPolyfills = async () => {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};
